// extracted by mini-css-extract-plugin
export default {"navbarPage":"NavBarPage_navbarPage__NoApt","navbarTestContent":"NavBarPage_navbarTestContent__cV1n5"};